export const HEADING_SIZES = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];